//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const banner = () => {
    const { handleResponse, handleError } = HandleApiResponse();

    async function get(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"
                },
            };
            // let query = JSON.stringify(values);
            let res = await fetch(
                `${config.host}/cdr-panel/banner`,
                obj
            );
            return handleResponse(res);
        } catch (err) {
            handleError(err);
        }
    }
    async function getSignature(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"
                },
            };
            // let query = JSON.stringify(values);
            let res = await fetch(
                `${config.host}/cdr-panel/banner/signature`,
                obj
            );
            return handleResponse(res);
        } catch (err) {
            handleError(err);
        }
    }
    async function getschedule(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"
                },
            };
            // let query = JSON.stringify(values);
            let res = await fetch(
                `${config.host}/cdr-panel/banner/schedule`,
                obj
            );
            return handleResponse(res);
        } catch (err) {
            handleError(err);
        }
    }


    async function upload(values) {
        try {
            const obj = {
                method: "POST",
                credentials: "include",
                body: values,
            };
    
            const res = await fetch(
                `${config.host}/cdr-panel/banner`, // ← use backticks here
                obj
            );
    
            return handleResponse(res);
        } catch (err) {
            handleError(err);
        }
    }
    async function uploadSignature(values) {
        try {
            const obj = {
                method: "POST",
                credentials: "include",
                body: values,
            };
    
            const res = await fetch(
                `${config.host}/cdr-panel/banner/signature-upload`, // ← use backticks here
                obj
            );
    
            return handleResponse(res);
        } catch (err) {
            handleError(err);
        }
    }

    

    async function update(values) {
        try {
            const obj = {
                method: "POST",
                credentials: 'include',
                headers: {
                  "Content-Type": "application/json"          
                },
                body: JSON.stringify(values),
              };
    
            const res = await fetch(
                `${config.host}/cdr-panel/banner/update`, // ← use backticks here
                obj
            );
    
            return handleResponse(res);
        } catch (err) {
            handleError(err);
        }
    }
    async function updateSignature(values) {
        try {
            const obj = {
                method: "POST",
                credentials: 'include',
                headers: {
                  "Content-Type": "application/json"          
                },
                body: JSON.stringify(values),
              };
    
            const res = await fetch(
                `${config.host}/cdr-panel/banner/signature-update`, // ← use backticks here
                obj
            );
    
            return handleResponse(res);
        } catch (err) {
            handleError(err);
        }
    }
    async function uploadTargetAccounts(values) {
        try {
            const obj = {
                method: "POST",
                credentials: "include",
                body: values,
            };
    
            const res = await fetch(
                `${config.host}/cdr-panel/banner/target-upload`, // ← use backticks here
                obj
            );
    
            return handleResponse(res);
        } catch (err) {
            handleError(err);
        }
    }
    async function getTargetAccountsBanner(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"
                },
            };
            // let query = JSON.stringify(values);
            let res = await fetch(
                `${config.host}/cdr-panel/banner/target-accounts`,
                obj
            );
            return handleResponse(res);
        } catch (err) {
            handleError(err);
        }
    }
    async function updateTargetAccounts(values) {
        try {
            const obj = {
                method: "POST",
                credentials: 'include',
                headers: {
                  "Content-Type": "application/json"          
                },
                body: JSON.stringify(values),
              };
    
            const res = await fetch(
                `${config.host}/cdr-panel/banner/target-update`, // ← use backticks here
                obj
            );
    
            return handleResponse(res);
        } catch (err) {
            handleError(err);
        }
    }
    
  async function getTargetAccounts(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/banner/target-accounts-id?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  async function exportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/banner/export`,
        obj
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err)
    }
  }
  async function searchTargetAccounts(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/banner/search-target?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  async function updateTargetAccountsSingle(values) {
    try {
        const obj = {
            method: "POST",
            credentials: 'include',
            headers: {
              "Content-Type": "application/json"          
            },
            body: JSON.stringify(values),
          };

        const res = await fetch(
            `${config.host}/cdr-panel/banner/target-update-single`, // ← use backticks here
            obj
        );

        return handleResponse(res);
    } catch (err) {
        handleError(err);
    }
}

async function uploadTier(values) {
    try {
        const obj = {
            method: "POST",
            credentials: "include",
            body: values,
        };

        const res = await fetch(
            `${config.host}/cdr-panel/banner/tier-upload`, // ← use backticks here
            obj
        );

        return handleResponse(res);
    } catch (err) {
        handleError(err);
    }
}

async function updateTier(values) {
    try {
        const obj = {
            method: "POST",
            credentials: 'include',
            headers: {
              "Content-Type": "application/json"          
            },
            body: JSON.stringify(values),
          };

        const res = await fetch(
            `${config.host}/cdr-panel/banner/tier-update`, // ← use backticks here
            obj
        );

        return handleResponse(res);
    } catch (err) {
        handleError(err);
    }
}

async function getTier(values) {
    try {
        const obj = {
            method: "GET",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json"
            },
        };
        // let query = JSON.stringify(values);
        let res = await fetch(
            `${config.host}/cdr-panel/banner/tier`,
            obj
        );
        return handleResponse(res);
    } catch (err) {
        handleError(err);
    }
}

    return {
        get,
        upload,
        update,
        getschedule,
        updateSignature,
        uploadSignature,
        getSignature,
        uploadTargetAccounts,
        getTargetAccounts,
        updateTargetAccounts,
        getTargetAccountsBanner,
        exportAPI,
        searchTargetAccounts,
        updateTargetAccountsSingle,
        uploadTier,
        updateTier,
        getTier

    };
};

export default banner;
